import React from "react";

// Placeholder for future policies view
const AdminPolicies = () => {
  return <div />;
};

AdminPolicies.propTypes = {};

export default AdminPolicies;
